import { render, staticRenderFns } from "./LiveSettings.vue?vue&type=template&id=2083db24&scoped=true"
import script from "./LiveSettings.vue?vue&type=script&lang=js"
export * from "./LiveSettings.vue?vue&type=script&lang=js"
import style0 from "./LiveSettings.vue?vue&type=style&index=0&id=2083db24&prod&lang=scss&scoped=true"
import style1 from "./LiveSettings.vue?vue&type=style&index=1&id=2083db24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083db24",
  null
  
)

export default component.exports